"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;
var validate = function validate(referenceContainer) {
  var buttonIsDisabled = referenceContainer['paymentSubmitBtn'].hasAttribute('disabled');
  return !buttonIsDisabled;
};
exports.validate = validate;